module.exports = __webpack_public_path__ + "static/assets/0e40027d35a62d5ebfdd7b899a1e274c.svg";